import { Component, Inject, OnInit, Type, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContainerRefDirective } from '../../directives/container-ref/container-ref.directive';
import { IPopupScreenData } from '../../models/popup-screen-data.model';
import { PopupItem } from '../../services/popup/popup-item';
import { PopupService } from '../../services/popup/popup.service';
import { CommonService } from 'src/app/common.service';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @ViewChild(ContainerRefDirective, {static: true}) containerRef!: ContainerRefDirective;
  
  title:string = "";
  popupItem:PopupItem;

  constructor(
    private dialogRef: MatDialogRef<PopupComponent>, 
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData,
    private popupService:PopupService,
    public commonService:CommonService

  ) { }

  ngOnInit(): void {
    this.title = this.data.screenTitle;
    this.popupItem = this.popupService.getPopup(this.data.component);
  }

  ngAfterViewInit(){
    this.loadComponent();
  }

  loadComponent() {
    const popup = this.popupItem;

    const viewContainerRef = this.containerRef.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent<any>(popup.component);
    componentRef.instance.data = this.data //popup.data;
  }

  closePopup(){
    this.dialogRef.close();
  }

}
